import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
import footerlogo from '../img/footer-logo.jpg'
// import * as contentful from 'contentful';
import Client from "../contentful";

import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
export default class StudentCenteredPartnership extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
        
            array1:[],
            array2:[],
            array3:[]
          
        }
    }


    formatData(items) {
       
        
        let tempItems = items.map(item => {
          let id = item.sys.id;
          
          let array1 = item.fields?.arrayOfGlobalStudiesInstituteUniversities?.global_Studies_Institute

          let array2 = item.fields?.arrayOfGlobalStudiesInstituteUniversities?.Universities

          let array3 = item.fields?.arrayOfGlobalStudiesInstituteUniversities?.Shorelight

          
            this.setState({
                array1: array1,
                array2: array2,
                array3: array3 
            })
       
       
        
     })
     
     
   
     
        return tempItems;
       
        
     
     }
    

    componentDidMount() {
        Client.getEntries({
            content_type : "organizationStructure"
          })
          .then(response=>{
            console.log(response.items)
            this.formatData(response.items)
          })

    }


    render() {
       
        return(
            <div>
            

            
           

<div class="row">
   <div class="col-lg-4">
      <div class="shadow p-25 technology height-100 bg-2">
         <h4 class="text-center mt-2 mb-4">Global Studies Institute</h4>

         {
  this.state.array1.map(item => (

<p class=""><span class="mr-2"><i class="fa fa-angle-right"></i></span>{item}</p>

))      
}
      </div>
   </div>
   <div class="col-lg-4">
      <div class="shadow p-25 technology height-100 bg-2">
         <h4 class="text-center mt-2 mb-4">Universities</h4>

         {
  this.state.array2.map(item => (
  <p ><span class="mr-2"><i class="fa fa-angle-right"></i></span> {item}</p>
  ))
    }


      </div>
   </div>
   <div class="col-lg-4">
      <div class="shadow p-25 technology height-100 bg-2">
         <h4 class="text-center mt-2 mb-4">Shorelight</h4>
         {
  this.state.array3.map(item => (
         <p class="mt-4"><span class="mr-2"><i class="fa fa-angle-right"></i></span> {item}</p>
  ))
    }

      </div>
   </div>
</div>
</div>
            
        )
    }
}